import WapiPoint2D from "../models/WapiPoint2D";
import WapiPolygon2D from "../models/WapiPolygon2D";
import { GetWapiCoordinateOrder, WapiCoordinateOrder } from '../constants/index.js'


export function wapiPolygon2DToGeoJson(wapiPolygon2D, coordinateOrder = [1, 0]) {
  const wapiCoordinateOrder = GetWapiCoordinateOrder(coordinateOrder);
  const geojson = {
    "type": "Feature",
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        []
      ]
    },
    'properties': {
      'id': wapiPolygon2D.id,
      'name': wapiPolygon2D.name,
      'user_id': wapiPolygon2D.user_id,
    }
  };

  wapiPolygon2D.area.points.forEach(p => {
    if (wapiCoordinateOrder === WapiCoordinateOrder.LatLon) {
      geojson.geometry.coordinates[0].push([p.y, p.x]);
    } else {
      geojson.geometry.coordinates[0].push([p.x, p.y]);
    }

  });

  return geojson;
}



export function wapiBillingPresetToGeoJson(wapiBillingPreset, userId, coordinateOrder = [1, 0]) {
  const wapiCoordinateOrder = GetWapiCoordinateOrder(coordinateOrder);
  const geojson = {
    "type": "Feature",
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        []
      ]
    },
    'properties': {
      'id': wapiBillingPreset.preset_id,
      'name': wapiBillingPreset.name,
      'user_id': userId,
    }
  };

  wapiBillingPreset.area.points.forEach(p => {
    if (wapiCoordinateOrder === WapiCoordinateOrder.LatLon) {
      geojson.geometry.coordinates[0].push([p.y, p.x]);
    } else {
      geojson.geometry.coordinates[0].push([p.x, p.y]);
    }

  });

  return geojson;
}


export function geoJsonToWapiPolygon(geoJson, coordinateOrder = [1, 0]) {
  const wapiCoordinateOrder = GetWapiCoordinateOrder(coordinateOrder);
  const wapiPolygon2D = new WapiPolygon2D();
  geoJson.geometry.coordinates[0].forEach(x => {
    if (wapiCoordinateOrder === WapiCoordinateOrder.LatLon) {
      wapiPolygon2D.points.push(new WapiPoint2D(x[1], x[0]));
    } else {
      wapiPolygon2D.points.push(new WapiPoint2D(x[0], x[1]));
    }
  });
  return wapiPolygon2D;
}